import React, { Fragment } from "react";

import {
  Popover,
  PopoverButton,
  PopoverPanel,
  Transition,
} from "@headlessui/react";
import {
  ArrowLeftEndOnRectangleIcon,
  ChevronUpDownIcon,
  UserIcon,
} from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

const UserProfilePopover = ({ user, onSignOut, onClose }) => {
  return (
    <Popover className="relative z-50">
      <PopoverButton className="flex items-center w-full">
        <div className="flex items-center gap-2 p-4 justify-between outline outline-1 outline-offset-[-1px] shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05)] outline-gray-200 rounded-xl w-full">
          <div className="flex items-center gap-2 overflow-hidden w-full">
            <img
              src={user.avatar || "/avatar.png"}
              alt="User picture"
              className="size-10 rounded-full object-cover border border-gray-300"
            />

            <div className="flex flex-col min-w-0">
              <p className="text-sm font-semibold text-gray-900 leading-tight truncate p-0 m-0 text-left">
                {user.name || "User"}
              </p>
              <p className="text-sm font-normal text-slate-600 leading-tight truncate p-0 m-0 text-left">
                {user.email || "Email"}
              </p>
            </div>
          </div>

          <ChevronUpDownIcon className="size-5 text-slate-600 cursor-pointer hover:bg-gray-50" />
        </div>
      </PopoverButton>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <PopoverPanel className="absolute z-50 right-0 mb-2 w-48 origin-bottom-right rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 transform translate-y-[-100%]">
          {({ close }) => (
            <div className="p-4">
              <div className="space-y-2">
                <Link
                  to="/dashboard/profile"
                  className="flex items-center w-full px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
                  onClick={close}
                >
                  <UserIcon className="size-5 mr-2 text-gray-500" />
                  Your Profile
                </Link>
                <button
                  onClick={onSignOut}
                  className="flex items-center w-full px-3 py-2 text-sm text-red-600 hover:bg-red-100 rounded-md"
                >
                  <ArrowLeftEndOnRectangleIcon className="h-5 w-5 mr-2 text-red-500" />
                  Sign Out
                </button>
              </div>
            </div>
          )}
        </PopoverPanel>
      </Transition>
    </Popover>
  );
};

export default UserProfilePopover;
